import { render, staticRenderFns } from "./YoukeliangGaikuang.vue?vue&type=template&id=40d03305&scoped=true&"
import script from "./YoukeliangGaikuang.vue?vue&type=script&lang=js&"
export * from "./YoukeliangGaikuang.vue?vue&type=script&lang=js&"
import style0 from "./YoukeliangGaikuang.vue?vue&type=style&index=0&id=40d03305&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d03305",
  null
  
)

export default component.exports